import { connect } from 'react-redux';
import { EmployeeDataSource } from '../../components/pages/basics/EmployeeDataSource';
import { IApplicationState } from '../../store';
import { ActionCreators as HierarchyActionCreators } from '../../store/ExternalHierarchyStore';
import { ActionCreators as SurveyActionCreators } from '../../store/SurveyStore';

const mapStateToProps = (state: IApplicationState) => {
	const { survey, audienceSource } = state.survey.surveyEditModel;
	const { audienceSource: originalSource } = state.survey.lastSavedSurveyEditModel;
	const sourceTypeChanged = survey.audienceSourceType !== audienceSource.audienceSourceType;
	const hierarchyFileChanged =
		originalSource.externalHierarchyId !== null &&
		originalSource.externalHierarchyId !== undefined &&
		originalSource.externalHierarchyId !== audienceSource.externalHierarchyId;
	const hrisFileChanged =
		originalSource.externalHrisId !== null &&
		originalSource.externalHrisId !== undefined &&
		originalSource.externalHrisId !== audienceSource.externalHrisId;

	return {
		...state.externalHierarchy,
		audienceSource: state.survey.surveyEditModel.audienceSource,
		validationResults: state.surveyBuilder.validationResults,
		showChangeWarning:
			(survey.audienceSourceType !== null && survey.audienceSourceType !== undefined && sourceTypeChanged) ||
			hierarchyFileChanged ||
			hrisFileChanged,
	};
};

export const EmployeeDataSourceContainer = connect(mapStateToProps, { ...SurveyActionCreators, ...HierarchyActionCreators })(
	EmployeeDataSource,
);
